import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, TextField } from "@material-ui/core";
import httpUtils from "../../utils/http.utils";
import config from "../../config";
import { dispatch } from "../../events";
import { types } from "../../events/user";
import { types as loaderTypes } from "../../events/loader";

const useStyles = makeStyles((theme) => ({
    inputBlockingReason: {
        width: '100%'
    }
}));

const BlockUser = ({ user, onClose }) => {
    const classes = useStyles();
    // Dialog
    const [blockingReason, setBlockingReason] = React.useState('');
    const valideBlockUser = () => {
        if (!!blockingReason) {
            dispatch(loaderTypes.SET_LOADER);
            httpUtils.put(`${config.BACK_API}/api/user/${user.id}/block`, { blockingReason });
            dispatch(types.BLOCK_USER, { user });
            onClose();
            dispatch(loaderTypes.UNSET_LOADER);
        }
    }
    return (
        <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{"Why do you want to block this user ?"}</DialogTitle>
            <DialogContent>
                <TextField
                    id="outlined-multiline-static"
                    className={classes.inputBlockingReason}
                    label="Blocking reason"
                    value={blockingReason}
                    onChange={(e) => setBlockingReason(e.target.value)}
                    multiline
                    rows={5}
                    variant="outlined"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={valideBlockUser} color="primary" autoFocus>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default BlockUser;